module.exports = ['$q', 'Promise', 'User', 'WmsvrClient', '$translate', function ($q, Promise, User, WmsvrClient, $translate) {
  // 修改密码
  function changePassword(options) {
    const deferred = $q.defer()
    Promise.wmCall('user:changePassword', options).then(function (data) {
      deferred.resolve(data)
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }
  // 获取密码策略
  function getPasswordPolicy() {
    const deferred = $q.defer()
    Promise.wmCall('user:getPasswordPolicy', {attrIds: ['prohibitPasswords']}).then(function (data) {
      if (data.code && data.code === 'S_OK') {
        deferred.resolve({ minLength: data.var.minLength, minStrength: data.var.minStrength, rules: formatPasswordPolicy(data.var), tip: generatePasswordTip(data.var.minLength) })
      }
    }, function (error) {
      deferred.reject(error)
    })
    return deferred.promise
  }

  // 密码策略(每个规则都是一个函数，传递password进行判断，返回true就代表满足规则，反之不满足规则)
  function formatPasswordPolicy(data) {
    const userName = data.dnEmail.split('@')[0]
    return {
      WEAK: {
        isOverMinLength: getLengthFunc(data.requireLength['WEAK']), // 最短长度
        isNoProhibit: getProhibitFunc(data.prohibitPasswords) // 不能使用禁用密码
      },
      FAIR: {
        isOverMinLength: getLengthFunc(data.requireLength['FAIR']), // 最短长度
        isNoProhibit: getProhibitFunc(data.prohibitPasswords), // 不能使用禁用密码
        isNoSameWithUsername: getUserNameFunc(userName), // 不能与用户名相同
        isDiffCharacter: isDiffCharacter, // 不能使用完全相等的字符
        isNoConsecutive: isNoConsecutive // 不能是连续的数字或字母
      },
      GOOD: {
        isOverMinLength: getLengthFunc(data.requireLength['GOOD']), // 最短长度
        isNoProhibit: getProhibitFunc(data.prohibitPasswords), // 不能使用禁用密码
        isNoSameWithUsername: getUserNameFunc(userName), // 不能与用户名相同
        isIncludeTwoType: isIncludeTwoType // 至少包含两种字符类型（数字，大写字母，小写字母，特殊符号）
      },
      STRONG: {
        isOverMinLength: getLengthFunc(data.requireLength['STRONG']), // 最短长度
        isNoProhibit: getProhibitFunc(data.prohibitPasswords), // 不能使用禁用密码
        isNoSameWithUsername: getUserNameFunc(userName), // 不能与用户名相同
        isIncludeThreeType: isIncludeThreeType // 至少包含3种字符类型（数字，大写字母，小写字母，特殊符号）
      }
    }
  }
  // 生成密码长度及字符组成提示语
  function generatePasswordTip(minLength) {
    return $translate.instant('LOGIN.PASSWORD_RESET_TIP', { count: minLength })
  }
  // 根据给定的长度返回判定函数
  function getLengthFunc(len) {
    return function (password) {
      if (password) {
        return password.length >= len
      } else {
        return false
      }
    }
  }
  // 根据给定的禁用密码列表返回判定函数
  function getProhibitFunc(list) {
    return function (password) {
      if (password) {
        return !list[password]
      } else {
        return true
      }
    }
  }
  // 根据给定的用户名返回判定函数
  function getUserNameFunc(userName) {
    return function (password) {
      return userName !== password
    }
  }
  // 判断密码是否不是由完全相等的字符组成
  function isDiffCharacter(password) {
    const passworldLetterArray = password.split('')
    let isDiff = true
    if (password) {
      const letter = passworldLetterArray[0]
      isDiff = false
      for (let i = 0; i < passworldLetterArray.length; i++) {
        if (passworldLetterArray[i] !== letter) {
          isDiff = true
          break
        }
      }
    }

    return isDiff
  }
  // 判断密码是否不是由连续的数字或字母组成
  function isNoConsecutive(password) {
    let isConsecutive = true
    let preLetterCharCode = ''
    if (password) {
      const passworldLetterArray = password.split('')
      for (let i = 1; i < passworldLetterArray.length; i++) {
        if (preLetterCharCode) {
          if (passworldLetterArray[i].charCodeAt() - 1 !== preLetterCharCode) {
            isConsecutive = false
            break
          }
        }
        preLetterCharCode = passworldLetterArray[i].charCodeAt()
      }
    }
    return !isConsecutive
  }
  // 判断密码是否至少包含两种字符类型
  function isIncludeTwoType(password) {
    let typeNum = 0
    if (password.match(/[a-z]+/g)) { // 小写字母
      typeNum = typeNum + 1
    }
    if (password.match(/[A-Z]+/g)) { // 大写字母
      typeNum = typeNum + 1
    }
    if (password.match(/[\d]+/g)) { // 数字
      typeNum = typeNum + 1
    }
    if (password.match(/[^A-Za-z0-9]+/g)) { // 特殊字符
      typeNum = typeNum + 1
    }
    if (typeNum >= 2) {
      return true
    } else {
      return false
    }
  }
  // 判断密码是否至少包含三种字符类型
  function isIncludeThreeType(password) {
    let typeNum = 0
    if (password.match(/[a-z]+/g)) { // 小写字母
      typeNum = typeNum + 1
    }
    if (password.match(/[A-Z]+/g)) { // 大写字母
      typeNum = typeNum + 1
    }
    if (password.match(/[\d]+/g)) { // 数字
      typeNum = typeNum + 1
    }
    if (password.match(/[^A-Za-z0-9]+/g)) { // 特殊字符
      typeNum = typeNum + 1
    }
    if (typeNum >= 3) {
      return true
    } else {
      return false
    }
  }
  return {
    getPasswordPolicy: getPasswordPolicy,
    changePassword: changePassword
  }
}]



// WEBPACK FOOTER //
// ./src/js/setting/changePassword/changePasswordService.js